import { Injectable } from '@angular/core';
import { filter, take, tap } from 'rxjs/operators';
import { SubscriptionsFacade } from '@api-ui-app/src/app/subscriptions/+state/subscriptions.facade';
import { GelatoPlusFeatures } from '@gelato-api-ui/sdk/src/lib/shared/subscriptions-shared/lib/gelato-plus-features';
import { GelatoPlusPopupLocations } from '@gelato-api-ui/sdk/src/lib/shared/subscriptions-shared/lib/gelato-plus-popup-locations';
import { GelatoSubscriptionModalType } from '@gelato-api-ui/sdk/src/lib/shared/subscriptions-shared/lib/gelato-subscription-modal';
import { GelatoPlusModalService } from '@gelato-api-ui/sdk/src/lib/shared/subscriptions-shared/services/gelato-plus-modal.service';

@Injectable({
  providedIn: 'root',
})
export class PriceNavigatorPaywallService {
  private isGelatoGoldSubscriptionActive$ = this.subscriptionsFacade.gelatoPlusGoldIsActive$;

  constructor(
    private readonly subscriptionsFacade: SubscriptionsFacade,
    private readonly gelatoPlusModalService: GelatoPlusModalService,
  ) {}

  checkUserSubscription() {
    return this.isGelatoGoldSubscriptionActive$.pipe(
      filter(isGelatoGoldActive => isGelatoGoldActive !== null),
      take(1),
      tap(isGelatoGoldActive => {
        if (!isGelatoGoldActive) {
          this.gelatoPlusModalService.open(
            GelatoPlusFeatures.priceNavigator,
            GelatoPlusPopupLocations.priceNavigator,
            GelatoSubscriptionModalType.GELATO_GOLD,
          );
        }
      }),
    );
  }
}
